import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { CreateChannelFlow } from "../schemas/schemas_0";
export { $Command };
export class CreateChannelFlowCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "CreateChannelFlow", {})
    .n("ChimeSDKMessagingClient", "CreateChannelFlowCommand")
    .sc(CreateChannelFlow)
    .build() {
}
